import React from 'react';
import { IconButton, Typography, TextField } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import { DESCRIPTION, FROM, TO, DESC_MAP, isElementInRule } from './_constants';

export const EditableElementsRows = ({ data, rule, onEditElement, onDuplicateElement, onRemoveElement }) => {
    const inputProps = {
        style: {
            padding: '5px 5px',
        },
    };

    const canEdit = (index) => {
        const category = data[index][DESCRIPTION];
        return data.some((element, i) => i !== index && element[DESCRIPTION] === category);
    };

    return (
        <>
            {Array.isArray(data) ? (
                data.map(
                    (element, index) =>
                        isElementInRule(element, rule) && (
                            <div className="responsibility-elements-row" key={index}>
                                <Typography>{DESC_MAP.get(element[DESCRIPTION])}</Typography>
                                <div>
                                    <TextField
                                        type="text"
                                        value={element[FROM]}
                                        inputProps={inputProps}
                                        onChange={(event) => onEditElement(event, index, FROM)}
                                    ></TextField>
                                </div>
                                <div>
                                    <TextField
                                        type="text"
                                        value={element[TO]}
                                        inputProps={inputProps}
                                        onChange={(event) => onEditElement(event, index, TO)}
                                    ></TextField>
                                </div>
                                <div className="responsibility-elements-buttons">
                                    <IconButton onClick={() => onDuplicateElement(index)}>
                                        <ContentCopyIcon sx={{ fontSize: '16px' }} />
                                    </IconButton>
                                    <IconButton onClick={() => onRemoveElement(index)} disabled={!canEdit(index)}>
                                        <DeleteIcon sx={{ fontSize: '16px' }} />
                                    </IconButton>
                                </div>
                            </div>
                        )
                )
            ) : (
                <Typography>Loading ...</Typography>
            )}
        </>
    );
};
